import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/zh-tw';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import ReactModal from 'react-modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../calendar.css';
import { useMemo } from "react";
import ShiftModal from '../components/ShiftModal';
import StaffView from '../components/StaffView';   // ✨ 新增這行
import LeaveLimitModal from '../components/LeaveLimitModal';
import LeaveModal from '../components/ApplyLeaveModal';
import DutyModal from '../components/DutyModal';
import CustomDayHeader from '../components/CustomDayHeader';
import NotifySortModal from '../components/NotifySortModal';
import OfficerModal from '../components/OfficerModal';
moment.updateLocale('zh-tw', {
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  week: { dow: 1 },
});


const localizer = momentLocalizer(moment);

const formats = {
  monthHeaderFormat: (date) => moment(date).locale('zh-tw').format('YYYY年M月'),
  weekdayFormat: (date) => moment(date).locale('zh-tw').format('dd'),
};

const buildLeaveSuccessAlert = (result) => {
  let msg = `✅ ${result.message || '請假成功'}`;
  const n = result.notify;
  if (!n) return msg;

  if (n.skipped) {
    msg += `\n⚠️ 通知略過：${n.reason || '未知原因'}`;
    if (n.target) msg += `（${n.target}）`;
    return msg;
  }

  if (n.target) {
    const position = `第 ${n.round} 輪第 ${n.orderIndex} 位`;
    if (n.dryRun) {
      msg += `\n📨 本應通知：${n.target}（${position}）`;
    } else if (n.sent) {
      msg += `\n📨 已通知：${n.target}（${position}）`;
    }
  }
  return msg;
};

const LeaveCalendar = () => {
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  // const [currentDate, setCurrentDate] = useState(moment()); // ✅ 預設為當月
  const [currentDate, setCurrentDate] = useState(moment().add(1, 'month')); // ✅ 預設為下個月

  const [shiftType, setShiftType] = useState(() => {
    return localStorage.getItem('shiftType') || '甲';
  });

  const [staffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(localStorage.getItem('selectedStaff') || '');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [showModalContent, setShowModalContent] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [modalDate, setModalDate] = useState(null);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(moment().add(1, 'day').toDate());
  const [agent, setAgent] = useState('');
  const [leaveType, setLeaveType] = useState('補休');
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);
  const [notifyList, setNotifyList] = useState([]);

  const [isShiftModalOpen, setIsShiftModalOpen] = useState(false);
  const [isStaffViewOpen, setIsStaffViewOpen] = useState(false);
  const [shiftAssignList, setShiftAssignList] = useState([]);
  const 班別代號 = shiftType.replace('班', '');

  const [班別清單, set班別清單] = useState({ 甲: [], 乙: [] });
  const [未分班清單, set未分班清單] = useState([]);
  const [isLimitModalOpen, setLimitModalOpen] = useState(false);
  const [selectedLimits, setSelectedLimits] = useState({}); // { '2025-05-23': { leave: 2, stay: 1 } }
  // 結構: { '2025-05-23': { leave: 3, stay: 1 } }
  const [isLimitLoaded, setIsLimitLoaded] = useState(false);
  const [usedLeaveCount, setUsedLeaveCount] = useState({});
  // 結構: { '2025-05-23': 1 }

  const [usedStayCount, setUsedStayCount] = useState({});
  // 結構: { '2025-05-23': 0 }
  const [myLeaveDates, setMyLeaveDates] = useState([]);
  // const openLeaveLimitModal = () => {
  //   setLimitModalOpen(true);
  // };
  const [dayLeaveRecords, setDayLeaveRecords] = useState([]);
  const [isDutyModalOpen, setIsDutyModalOpen] = useState(false);
  const [dutyByDate, setDutyByDate] = useState({});
  const [leaveApplicationsByDate, setLeaveApplicationsByDate] = useState({});
  const [totalOvernightRemaining, setTotalOvernightRemaining] = useState(0);
  const [minOnDuty, setMinOnDuty] = useState(10); // ✅ 預設最低警力為 10
  const [currentNotifyUser, setCurrentNotifyUser] = useState(null);

  const [currentNotifyInfo, setCurrentNotifyInfo] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(Date.now()); // ⏱️ 重新拉資料依據
  const [hasLeaveAvailable, setHasLeaveAvailable] = useState(true);
  const [isOfficerModalOpen, setIsOfficerModalOpen] = useState(false);
  const [officerList, setOfficerList] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('auth') === 'true';
  });
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);
  const [inputPassword, setInputPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lineNotifyEnabled, setLineNotifyEnabled] = useState(true);

  const fetchCurrentNotifyInfo = async () => {
    const monthStr = moment(currentDate).format('YYYY-MM');
    try {
      const res = await fetch(`/api/notify-progress/current?month=${monthStr}&shiftType=${shiftType}`);
      const data = await res.json();
      if (data && data.user_name) {
        setCurrentNotifyInfo({
          name: data.user_name,
          round: data.round,
          order: data.order_index
        });
      } else {
        setCurrentNotifyInfo(null);
      }
    } catch (err) {
      console.error("🚨 讀取目前通知進度失敗", err);
      setCurrentNotifyInfo(null);
    }
  };

  const handleUpdateName = async (id, newName) => {
    try {
      const res = await fetch('/api/staff/updateInfo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, name: newName })
      });
      const result = await res.json();

      if (result.success || res.ok) {
        // 更新本地列表
        setStaffList(prev => prev.map(s => s.id === id ? { ...s, name: newName } : s));

        // 更新班別清單
        set班別清單(prev => {
          const next = { ...prev };
          Object.keys(next).forEach(key => {
            next[key] = next[key].map(s => s.id === id ? { ...s, name: newName } : s);
          });
          return next;
        });

        // 更新未分班清單
        set未分班清單(prev => prev.map(s => s.id === id ? { ...s, name: newName } : s));

        // 如果目前選到這個人，也同步更新
        if (selectedStaff === staffList.find(s => s.id === id)?.name) {
          setSelectedStaff(newName);
        }

      } else {
        alert("❌ 改名失敗：" + (result.message || "未知原因"));
      }
    } catch (err) {
      console.error(err);
      alert("🚫 系統錯誤：" + (err.message || "無法連線到伺服器"));
    }
  };

  // 👉 然後配合 useEffect 呼叫
  useEffect(() => {
    fetchCurrentNotifyInfo();
  }, [currentDate, shiftType, lastUpdated]);



  useEffect(() => {
    const fetchMinOnDuty = async () => {
      try {
        const url = '/api/system-setting?key=minOnDuty';
        const res = await fetch(url);
        // 額外檢查回傳類型
        const contentType = res.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          const text = await res.text();
          throw new Error(`❌ 回傳不是 JSON：${text.slice(0, 100)}`);
        }

        const { value } = await res.json();

        if (typeof value !== 'number') {
          throw new Error(`⚠️ 回傳 JSON 結構不符: ${JSON.stringify(value)}`);
        }

        setMinOnDuty(value);
      } catch (err) {
        console.error("載入最低警力失敗", err);
      }
    };

    fetchMinOnDuty();
  }, []);

  useEffect(() => {
    const fetchLineNotifyEnabled = async () => {
      try {
        const res = await fetch('/api/system-setting?key=lineNotifyEnabled');
        const { value } = await res.json();
        setLineNotifyEnabled(value === null ? true : value === 1);
      } catch (err) {
        console.error('載入 LINE 通知設定失敗', err);
      }
    };

    fetchLineNotifyEnabled();
  }, []);

  useEffect(() => {
    fetch('/api/staff')
      .then((res) => res.json())
      .then((data) => {
        setStaffList(data); // ✅ 設定全體人員清單
        const group = { 甲: [], 乙: [], 未: [] };
        data.forEach((s) => {
          if (s.shift === '甲') group.甲.push(s);
          else if (s.shift === '乙') group.乙.push(s);
          else group.未.push(s);
        });
        set班別清單({
          甲: group.甲.sort((a, b) => a.id - b.id),
          乙: group.乙.sort((a, b) => a.id - b.id)
        });
        set未分班清單(group.未.sort((a, b) => a.id - b.id));
      })
      .catch((err) => console.error('無法取得人員資料', err));
  }, []);

  const isSupervisor = useMemo(() => {
    return staffList.slice(0, 2).some(s => s.name === selectedStaff);
  }, [staffList, selectedStaff]);
  // useEffect(() => {
  //   loadLeaveLimitsFromServer();   // ✅ 載入上限
  //   fetchUsedLeaveCount();         // ✅ 載入已請人數
  //   fetchMyLeaveDates();           // ✅ 標紅自己的請假日
  // }, [shiftType, currentDate]);
  useEffect(() => {
    if (!selectedStaff || staffList.length === 0) return;

    loadLeaveLimitsFromServer();
    fetchUsedLeaveCount(); // ✅ 會依照 isSupervisor 判斷
    fetchMyLeaveDates();
  }, [shiftType, currentDate, isSupervisor, selectedStaff, staffList]);


  useEffect(() => {
    if (isLimitModalOpen) {
      loadLeaveLimitsFromServer();
    }
  }, [currentDate, shiftType, isLimitModalOpen]);


  // 取得當月的使用者請假紀錄
  useEffect(() => {
    if (!selectedStaff) return; // ✅ 尚未選擇人員，跳過

    const fetchLeaveDates = async () => {
      try {
        const res = await fetch(`/api/my-leave-dates?user=${encodeURIComponent(selectedStaff)}`);
        const data = await res.json();

        if (Array.isArray(data.dates)) {
          setMyLeaveDates(data.dates.map(d => moment(d).format('YYYY-MM-DD')));
        } else {
          console.warn('⚠️ 回傳的 data.dates 不是陣列：', data);
          setMyLeaveDates([]);
        }
      } catch (err) {
        console.error('❌ 載入 my-leave-dates 失敗', err);
        setMyLeaveDates([]);
      }
    };

    fetchLeaveDates();
  }, [selectedStaff]);



  useEffect(() => {
    const fetchDutyRoster = async () => {
      const monthStr = moment(currentDate).format('YYYY-MM');

      try {
        const res = await fetch(`/api/duty-roster?month=${monthStr}`);
        const data = await res.json();
        setDutyByDate(data);
      } catch (err) {
        console.error('載入 duty roster 失敗', err);
      }
    };

    fetchDutyRoster();
  }, [currentDate]);



  const [originalLimits, setOriginalLimits] = useState({});

  const fetchLimitsFromServer = async () => {
    const res = await fetch(`/api/leave-limits?month=${currentMonth}&shiftType=${shiftType}`);
    const data = await res.json();

    const limits = {};
    data.forEach(item => {
      limits[item.date] = {
        leave: item.leave_limit,
        stay: item.stay_limit
      };
    });

    setSelectedLimits(limits);
    setOriginalLimits(limits); // ✅ 保存初始資料副本
  };


  // ✅ 把這段放到 component 外層的 function 裡
  const fetchLeaveRecords = async () => {
    const monthStr = moment(currentDate).format('YYYY-MM');
    try {
      const res = await fetch(`/api/leave-records?month=${monthStr}`);
      const data = await res.json();
      setLeaveApplicationsByDate(data);

    } catch (err) {
      console.error('❌ 載入請假記錄失敗', err);
    }
  };

  // const fetchLeaveRecords = async () => {
  // const monthStr = moment(currentDate).format('YYYY-MM');
  // try {
  //   const res = await fetch(`/api/leave-records?month=${monthStr}`);
  //   const data = await res.json();

  //   // ✅ 用 from_time 分組
  //   const grouped = {};
  //   data.forEach(record => {
  //     const dateStr = moment(record.from_date).format('YYYY-MM-DD');
  //     if (!grouped[dateStr]) grouped[dateStr] = [];
  //     grouped[dateStr].push(record);
  //   });

  // 然後保留 useEffect 呼叫它
  useEffect(() => {
    fetchLeaveRecords();
  }, [currentDate]);


  //     setLeaveApplicationsByDate(grouped);

  //     // ✅ 除錯
  //     console.log("✅ 請假紀錄分組完成", grouped);
  //   } catch (err) {
  //     console.error('❌ 載入請假記錄失敗', err);
  //   }
  // };


  const fetchMyLeaveDates = async () => {
    try {
      const res = await fetch(`/api/my-leave-dates?user=${selectedStaff}`);
      const data = await res.json();
      const formatted = data.dates.map(d => moment(d).format('YYYY-MM-DD'));
      setMyLeaveDates(formatted);
    } catch (err) {
      console.error('載入請假日期失敗', err);
    }
  };

  const isAlreadyApplied = myLeaveDates.includes(moment(modalDate).format("YYYY-MM-DD"));

  // const fetchLeaveLimits = async (currentDate, shiftType) => {
  //   const monthStr = moment(currentDate).format('YYYY-MM');
  //   const res = await fetch(`/api/leave-limits?month=${monthStr}&shiftType=${shiftType}`);
  //   const data = await res.json();

  //   const newLimits = {};
  //   data.forEach(item => {
  //     const dateStr = moment(item.date).format("YYYY-MM-DD");
  //     newLimits[dateStr] = {
  //       leave: item.leave_limit,
  //       stay: item.stay_limit
  //     };
  //   });
  //   // setLeaveLimits(newLimits);
  //   setSelectedLimits(newLimits);
  // };

  // const fetchUsedLeaveCount = async () => {
  //   const year = moment(currentDate).year();
  //   const month = (moment(currentDate).month() + 1).toString().padStart(2, '0');
  //   const monthStr = `${year}-${month}`;

  //   const [leaveRes, stayRes] = await Promise.all([
  //     fetch(`/api/used-leave-count?month=${monthStr}&shiftType=${shiftType}&type=補休`), // 或其他請假類型
  //     // fetch(`/api/used-leave-count?month=${monthStr}&shiftType=${shiftType}&type=外宿`)
  //   ]);

  //   const leaveData = await leaveRes.json();
  //   // const stayData = await stayRes.json();

  //   // 格式轉為 YYYY-MM-DD
  //   const normalize = (raw) => {
  //     const obj = {};
  //     Object.keys(raw).forEach(key => {
  //       const formatted = moment(new Date(key)).format('YYYY-MM-DD');
  //       obj[formatted] = raw[key];
  //     });
  //     return obj;
  //   };

  //   setUsedLeaveCount(normalize(leaveData));
  //   // setUsedStayCount(normalize(stayData));
  // };

  const fetchUsedLeaveCount = async () => {
    const year = moment(currentDate).year();
    const month = (moment(currentDate).month() + 1).toString().padStart(2, '0');
    const monthStr = `${year}-${month}`;

    const shiftTypes = isSupervisor ? ['甲', '乙'] : [shiftType]; // ✅ ← 重點

    const results = await Promise.all(
      shiftTypes.map(type =>
        fetch(`/api/used-leave-count?month=${monthStr}&shiftType=${type}&type=補休`)
          .then(res => res.json())
          .catch(() => ({}))
      )
    );

    // 合併多班結果
    const merged = results.reduce((acc, cur) => {
      for (const key in cur) {
        acc[key] = (acc[key] || 0) + cur[key];
      }
      return acc;
    }, {});

    const normalize = (raw) => {
      const obj = {};
      Object.keys(raw).forEach(key => {
        const formatted = moment(new Date(key)).format('YYYY-MM-DD');
        obj[formatted] = raw[key];
      });
      return obj;
    };

    setUsedLeaveCount(normalize(merged));

    // ✅ 檢查當月是否還有任一天可申請 leave
    const available = Object.keys(normalize(merged)).some(date => getRemainingLeave(date) > 0);
    setHasLeaveAvailable(available);
  };




  const isWeekend = (dateStr) => {
    const day = moment(dateStr).day();
    return day === 0 || day === 6;
  };


  const handleStaffChange = (e) => {
    const staff = e.target.value;
    setSelectedStaff(staff);
    localStorage.setItem('selectedStaff', staff);
  };

  const baseDate = moment('2025-05-20');

  const isShiftMatch = (date) => {
    if (isSupervisor) return true;
    const daysSinceBase = moment(date).startOf('day').diff(baseDate.clone().startOf('day'), 'days');
    const isEven = daysSinceBase % 2 === 0;
    return (shiftType === '甲' && isEven) || (shiftType === '乙' && !isEven);
  };

  const isInCurrentMonth = (date) => moment(date).month() === moment(currentDate).month();

  // const getRemainingOvernight = (dateStr) => {
  //   const stayLimit = selectedLimits[dateStr]?.stay || 0;

  //   // 計算當日的白宿紀錄數量
  //   const leaveRecords = leaveApplicationsByDate[dateStr] || [];
  //   const used = leaveRecords.filter(l => {
  //     const from = moment(l.from_time);
  //     const to = moment(l.to_time);
  //     return from.format('HH:mm') === '08:00' && to.format('HH:mm') === '17:00';
  //   }).length;

  //   return Math.max(0, stayLimit - used);
  // };

  // 🟢 是否可申請白宿

  const getRemainingOvernight = (dateStr, customLeaveApplications = {}) => {
    // ✅ 如果沒有手動設定 → 預設為 1
    let stayLimit = typeof selectedLimits[dateStr]?.stay === 'number'
      ? selectedLimits[dateStr].stay
      : 1; // ← 預設值寫在這裡
    const leaveRecords = customLeaveApplications[dateStr] || leaveApplicationsByDate[dateStr] || [];
    const dutyLeaders = dutyByDate[dateStr] || [];

    const 有分隊長值日 = dutyLeaders.some(name => name.includes('分隊長'));
    const 有分隊長請假 = leaveRecords.some(l => l.user.includes('分隊長'));

    if (有分隊長值日 || 有分隊長請假) {
      stayLimit -= 1;
    }

    const used = leaveRecords.filter(l => {
      const from = moment(l.from_time);
      const to = moment(l.to_time);
      return from.format('HH:mm') === '08:00' && to.format('HH:mm') === '17:00';
    }).length;
    return Math.max(0, stayLimit - used);
  };


  const canUseOvernight = (dateStr) => {
    const leaveRecords = leaveApplicationsByDate[dateStr] || [];
    const dutyLeaders = dutyByDate[dateStr] || [];
    const leaveFull = getRemainingLeave(dateStr) <= 0;
    const notWeekend = !isWeekend(dateStr);
    const dutyOnLeave = leaveRecords.some(l => l.user.includes('分隊長'));
    const whiteUsed = isOvernightUsed(dateStr);

    // ⛔ 若為週一至週五，且當日有「分隊長」值日，白宿直接禁止
    const weekday = moment(dateStr).day(); // 0=週日, 1=週一, ..., 6=週六
    const hasDutyLeader = dutyLeaders.some(name => name.includes('分隊長'));
    const isWeekday = weekday >= 1 && weekday <= 5;

    const whiteRemain = getRemainingOvernight(dateStr);

    if (isWeekday && hasDutyLeader) return false;

    // return leaveFull && notWeekend && !dutyOnLeave && !whiteUsed;
    return leaveFull && notWeekend && !dutyOnLeave && whiteRemain > 0;
  };

  const canShowOvernight = (dateStr) => {
    const leaveRecords = leaveApplicationsByDate[dateStr] || [];
    const dutyLeaders = dutyByDate[dateStr] || [];
    // const leaveFull = getRemainingLeave(dateStr) <= 0;
    const notWeekend = !isWeekend(dateStr);
    const dutyOnLeave = leaveRecords.some(l => l.user.includes('分隊長'));
    const whiteUsed = isOvernightUsed(dateStr);

    // ⛔ 若為週一至週五，且當日有「分隊長」值日，白宿直接禁止
    const weekday = moment(dateStr).day(); // 0=週日, 1=週一, ..., 6=週六
    const hasDutyLeader = dutyLeaders.some(name => name.includes('分隊長'));
    const isWeekday = weekday >= 1 && weekday <= 5;

    if (isWeekday && hasDutyLeader) return false;

    return notWeekend && !dutyOnLeave && !whiteUsed;
  };

  const isOvernightUsed = (dateStr) => {
    return (leaveApplicationsByDate[dateStr] || []).some(l => {
      const from = moment(l.from_time);
      const to = moment(l.to_time);
      return from.format('HH:mm') === '08:00' && to.format('HH:mm') === '17:00';
    });
  };



  const handleSelectSlot = (slotInfo) => {
    if (!selectedStaff) {
      alert("⚠️ 請先選擇申請人員");
      return;
    }

    const dateStr = moment(slotInfo.start).format("YYYY-MM-DD");
    const isOfficer = staffList.find(s => s.name === selectedStaff)?.is_officer;
    // ✅ 只能申請當月
    if (!isInCurrentMonth(slotInfo.start)) {
      alert('非當月日期，無法申請。');
      return;
    }

    if (!isOfficer && !isShiftMatch(slotInfo.start)) {
      alert('非' + shiftType + '班日期，無法申請');
      return;
    }

    // ✅ 判斷是否為班別日或可申請白宿
    if (!isShiftMatch(slotInfo.start) && !canUseOvernight(dateStr)) {
      // ✅ 不 return，仍然開啟 modal，但不允許送出
      setLeaveType('補休');
      setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
      setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());
      setModalDate(slotInfo.start);
      fetchDayLeaveRecords(slotInfo.start);
      setIsModalOpen(true);
      setTimeout(() => setShowModalContent(true), 10);
      return;
    }


    // ✅ 取得剩餘請假名額
    const leave = getRemainingLeave(dateStr);
    // const remainingLeave = getRemainingLeave(dateStr);
    // const remainingNight = getRemainingNight(dateStr);
    const { leave: remainingLeave, night: remainingNight } = getRemainingCombinedQuota(dateStr);

    // console.log('remainingLeave',remainingLeave);
    // console.log('remainingNight',remainingNight);
    // ✅ 判斷申請假別類型
    // if (isOfficer || leave > 0) {
    //   setLeaveType('補休');
    //   setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
    //   setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());
    // } else if (canUseOvernight(dateStr)) {
    //   setLeaveType('白宿');
    //   setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
    //   setToDate(moment(slotInfo.start).hour(17).minute(0).toDate());
    // } else {
    //   // ⚠️ 假別也選定，時間也給預設，但只是不能送出
    //   setLeaveType('補休'); // 或預設給補休
    //   setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
    //   setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());
    // }
    if (isOfficer || remainingLeave > 0) {
      // ✅ 有補休可請
      setLeaveType('補休');
      setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
      setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());
    } else if (remainingNight > 0) {
      // ✅ 只有夜假可請
      setLeaveType('外宿');
      setFromDate(moment(slotInfo.start).hour(17).minute(0).toDate());
      setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());

      alert('⚠️ 僅剩外宿可申請');
    } else if (canUseOvernight(dateStr)) {
      // ✅ 補休、夜假都滿，但白宿還可以
      setLeaveType('白宿');
      setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
      setToDate(moment(slotInfo.start).hour(17).minute(0).toDate());
    }
    // ✅ 開啟請假 Modal 並載入該日請假紀錄
    setModalDate(slotInfo.start);
    fetchDayLeaveRecords(slotInfo.start);
    setIsModalOpen(true);
    setTimeout(() => setShowModalContent(true), 10);
  };



  // setIsModalOpen(true);
  // fetchDayLeaveRecords(slotInfo.start); // ⬅️ 這行負責抓當日請假名單
  // setModalDate(slotInfo.start);
  // setIsModalOpen(true);
  // setTimeout(() => setShowModalContent(true), 10);
  //   setModalDate(slotInfo.start);
  // setFromDate(moment(slotInfo.start).hour(8).minute(0).toDate());
  // setToDate(moment(slotInfo.start).add(1, 'day').hour(8).minute(0).toDate());
  // setIsModalOpen(true);
  // fetchDayLeaveRecords(slotInfo.start); // ← 加這行
  // setTimeout(() => setShowModalContent(true), 10);
  // const handleNavigate = (date) => setCurrentDate(date);
  const handleNavigate = (date) => setCurrentDate(moment(date));


  // const toggleShift = () => setShiftType((prev) => (prev === '甲' ? '乙' : '甲'));
  const toggleShift = () => {
    const newShift = shiftType === '甲' ? '乙' : '甲';
    setShiftType(newShift);
    localStorage.setItem('shiftType', newShift);
  };
  const handleClose = () => {
    setShowModalContent(false); // 關閉動畫 class
    setIsClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsClosing(false);
    }, 300);
  };




  const formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss'); // 台灣本地時間格式
  };

  const postNotifyProgress = async (user_name, shiftType, month) => {
    try {
      const res = await fetch('/api/notify-progress', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_name, shiftType, month })
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message || '未知錯誤');
      return true;
    } catch (err) {
      console.error('❌ 寫入通知進度失敗:', err);
      return false;
    }
  };

  const handleSubmit = async () => {
    if (!selectedStaff || !fromDate || !toDate || !agent || !leaveType) {
      alert("請填寫所有欄位");
      return;
    }

    setIsSubmitting(true); // ← 開始 loading

    try {
      const res = await fetch('/api/apply-leave', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user: selectedStaff,
          agent,
          leaveType,
          fromDate: formatDate(fromDate),
          toDate: formatDate(toDate),
          shiftType, // 👈 加上班別
          // ✅ 你應該加上：
          round: currentNotifyInfo?.round
        }),
      });

      const result = await res.json();
      if (result.success) {
        alert(buildLeaveSuccessAlert(result));
        setLastUpdated(Date.now()); // ✅ 觸發 useEffect 再次撈最新資料

        // await postNotifyProgress(selectedStaff, shiftType, monthStr);
        // 🔁 重新撈當月請假人數限制
        // await fetchLeaveLimits(currentDate, shiftType);
        await loadLeaveLimitsFromServer();
        // 🟥 更新使用者請假日期紅框
        await fetchUsedLeaveCount(); // 👈 這個是你現在缺的
        await fetchMyLeaveDates();
        await fetchLeaveRecords(); // ✅ 加這行才會更新白宿狀態
        handleClose(); // 關閉 modal
      } else {
        alert("❌ 申請失敗：" + result.message);
      }
    } catch (err) {
      console.error(err);
      alert("❌ 系統錯誤，請稍後再試");
    } finally {
      setIsSubmitting(false); // ← 結束 loading
    }
  };




  const handleDragStart = (e, staff) => {
    e.dataTransfer.setData("text/plain", JSON.stringify(staff));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const staff = JSON.parse(e.dataTransfer.getData("text/plain"));
    setNotifyList((prev) => [...prev, staff]);
  };

  const handleNotifySubmit = () => {
    // console.log("送出通知順序", notifyList);
    setIsSortModalOpen(false);
  };

  const fetchDayLeaveRecords = async (date) => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    const query = isSupervisor ?
      `/api/day-leave-records?date=${dateStr}` :
      `/api/day-leave-records?date=${dateStr}&shiftType=${shiftType}`;

    try {
      const res = await fetch(`/api/day-leave-records?date=${dateStr}`);
      const data = await res.json();
      setDayLeaveRecords(data);
    } catch (err) {
      console.error("讀取當日請假記錄失敗", err);
    }
  }

  const handleShiftDrop = (e, shift) => {
    e.preventDefault();
    const staff = JSON.parse(e.dataTransfer.getData("text/plain"));

    if (!['甲', '乙'].includes(shift)) {
      console.error('班別錯誤:', shift);
      return;
    }

    const newGroup = { ...班別清單 };
    newGroup.甲 = newGroup.甲.filter((p) => p.id !== staff.id);
    newGroup.乙 = newGroup.乙.filter((p) => p.id !== staff.id);
    const currentShiftGroup = newGroup[shift] || [];
    // newGroup[shift] = [...currentShiftGroup, staff].sort((a, b) => a.id - b.id);
    newGroup[shift] = [...(newGroup[shift] || []), staff].sort((a, b) => a.id - b.id);
    set班別清單(newGroup);
    set未分班清單((prev) => prev.filter((p) => p.id !== staff.id));

    fetch(`/api/staff/updateShift`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: staff.id, shift })
    })
      .then(res => res.json())
      .then(data => console.log('更新班別:', data))
      .catch(err => console.error('更新失敗', err));
  };
  // 新增一個「模擬 drop」的函式
  const assignViaClick = (staff, shift) => {
    const fakeEvent = {
      preventDefault: () => { },
      dataTransfer: {
        getData: () => JSON.stringify(staff),
      },
    };
    handleShiftDrop(fakeEvent, shift);
  };

  const handleRemoveFromShift = (staff) => {
    const newGroup = { ...班別清單 };
    newGroup[shiftType] = newGroup[shiftType].filter((p) => p.id !== staff.id);
    set班別清單(newGroup);
    set未分班清單((prev) => [...prev, staff].sort((a, b) => a.id - b.id));

    fetch(`/api/staff/updateShift`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: staff.id, shift: '' })
    })
      .then(res => res.json())
      .then(data => console.log('取消分班:', data))
      .catch(err => console.error('取消失敗', err));
  };

  const dayPropGetter = (date) => {
    if (!isInCurrentMonth(date)) {
      return { className: 'outside-month', style: { backgroundColor: '#eee', color: '#bbb', cursor: 'not-allowed' } };
    }
    if (!isShiftMatch(date)) {
      return { className: 'disabled-day', style: { backgroundColor: '#f0f0f0', color: '#aaa', cursor: 'not-allowed' } };
    }
    return { className: 'enabled-day' };
  };

  // useEffect(() => {
  //   console.log('🎯 usedLeaveCount 已更新:', usedLeaveCount);
  // }, [usedLeaveCount]);


  const DateCellWrapper = ({ value, children }) => {

    const dateStr = moment(value).format('YYYY-MM-DD');
    const isCurrentMonth = moment(value).month() === moment(currentDate).month();

    // ✅ 使用 baseDate 差距方式來判斷是否為甲班日或乙班日
    const isShiftDate = isShiftMatch(value);
    const isMyLeaveDay = myLeaveDates.includes(moment(value).format("YYYY-MM-DD"));

    if (!isLimitLoaded) return children;

    // const limit = selectedLimits[dateStr];
    // const hasLimit = limit && typeof limit.leave === 'number' && typeof limit.stay === 'number';
    // const maxLeave = getMaxLeave();
    // console.log("📅 渲染格子", dateStr, " duty =", dutyByDate[dateStr]);

    const leave = getRemainingLeave(dateStr); // 自動計算「班別人數 - 10」
    const night = getRemainingNight?.(dateStr) || 0; // 若還沒定義此函式，請定義

    const white = canUseOvernight(dateStr);
    const isAvailable = leave > 0 || night > 0; // ✅ 只要任一有名額就顯示藍底

    const hasLimit = true; // 永遠視為已設定
    // const isWeekend = [0, 6].includes(moment(dateStr).day());
    const hasDutyLeaderLeave = dutyByDate[dateStr]?.some(name =>
      (leaveApplicationsByDate[dateStr] || []).some(l => l.user === name)
    );

    return React.cloneElement(
      children,
      {
        style: {
          ...children.props.style,
          backgroundColor: isShiftDate
            ? isAvailable
              ? 'rgba(141, 215, 255)'              // 💡 當日滿 → 淺灰
              : 'rgb(239, 243, 247, 0.87)'   // 可申請 → 藍
            : 'rgba(239, 243, 247, 0.87)', // 非班別日 → 較灰

          pointerEvents: isShiftDate ? 'auto' : 'none',
          position: 'relative',
          border: isMyLeaveDay ? '2px solid red' : undefined,  // 🔴 紅框重點,
          boxSizing: 'border-box', // ✅ 加這行讓邊框向內收縮
          margin: '1px',
        },
        className: isCurrentMonth ? 'rbc-day-bg' : 'rbc-day-bg outside-month',
      },
      <>
        {children.props.children || null}

        {/* 左上角：值日提示（全班可見） */}
        {dutyByDate[dateStr]?.length > 0 && (
          <div className="absolute bottom-0 right-1  text-[16px] text-red-600 italic font-black pointer-events-none">
            {/* {dutyByDate[dateStr].join(', ')}值日 */}
            值
          </div>
        )}

        {isShiftDate && (
          <div className="absolute bottom-0 left-0 p-0 text-[14px] leading-[16px] pointer-events-none">
            {(() => {
              const { leave: showLeave, night: showNight } = getRemainingCombinedQuota(dateStr);

              const whiteRemain = getRemainingOvernight(dateStr);

              return (
                <>
                  <div className={`${showLeave > 0 ? 'text-[#005577] font-semibold' : 'text-gray-400'}`}>
                    休{showLeave}</div>
                  <div className={`${showNight > 0 ? 'text-[#ff4d4d] font-semibold' : 'text-gray-400'}`}>
                    外{showNight}</div>
                  {!isWeekend(dateStr) && (
                    <div className={`${whiteRemain > 0 ? 'text-purple-600 font-semibold' : 'text-gray-400'}`}>
                      白{whiteRemain}
                    </div>
                  )}
                </>
              );
            })()}

          </div>
        )}
        {/* ✅ 加入這一行：顯示班別 */}
        {/* {isSupervisor && (
          <div className="absolute bottom-0 right-0 pr-1 pb-1 text-[16px] text-gray-500 text-right pointer-events-none">
            {getDateShiftType(dateStr)}
          </div>
        )} */}
        {/* ✅ 加入這一行：自動 手動 請假人數 上限 */}
        {/* <div className="absolute bottom-0 right-0  text-[9px] italic text-yellow-900">
          {typeof selectedLimits[dateStr]?.leave === 'number' ? '手動' : '自動'}
        </div> */}

      </>
    );


  };


  const getShiftDates = (year, month, shiftType) => {
    const dates = [];
    const current = moment(`${year}-${String(month).padStart(2, '0')}-01`);
    const endOfMonth = current.clone().endOf('month');

    while (current.isSameOrBefore(endOfMonth, 'day')) {
      const dateStr = current.format("YYYY-MM-DD");
      if (isShiftMatch(current.toDate())) {
        dates.push(dateStr);
      }
      current.add(1, 'day');
    }

    return dates;
  };

  const getAllMonthDates = (year, month) => {
    const dates = [];
    const current = moment(`${year}-${String(month).padStart(2, '0')}-01`);
    const endOfMonth = current.clone().endOf('month');

    while (current.isSameOrBefore(endOfMonth, 'day')) {
      dates.push(current.format('YYYY-MM-DD'));
      current.add(1, 'day');
    }

    return dates;
  };



  // const calendarDates = useMemo(() => {
  //   const year = currentDate.year()
  //   const month = currentDate.month() + 1
  //   return getShiftDates(year, month, shiftType); // ✅ 使用最新 shiftType
  // }, [currentDate, shiftType]);

  const calendarDates = useMemo(() => {
    const year = currentDate.year();
    const month = currentDate.month() + 1;

    if (isSupervisor) {
      // 👀 主管看全部日曆
      const allDates = [];
      const current = moment(`${year}-${String(month).padStart(2, '0')}-01`);
      const endOfMonth = current.clone().endOf('month');
      while (current.isSameOrBefore(endOfMonth, 'day')) {
        allDates.push(current.format("YYYY-MM-DD"));
        current.add(1, 'day');
      }
      return allDates;
    }

    return getShiftDates(year, month, shiftType);
  }, [currentDate, shiftType, selectedStaff, staffList]);


  const allDates = useMemo(() => {
    const year = currentDate.year();
    const month = currentDate.month() + 1;
    return getAllMonthDates(year, month);
  }, [currentDate]);

  // const MIN_ON_DUTY = 10;

  // const getMaxLeave = (dateStr) => {
  //   const 班別人數 = 班別清單[shiftType]?.length || 0;
  //   const 值日人數 = dutyByDate[dateStr]?.length || 0;
  //   const 總上班人數 = 班別人數 + 值日人數;
  //   return Math.max(0, 總上班人數 - MIN_ON_DUTY);
  // };

  const getDateShiftType = (dateStr) => {
    const date = moment(dateStr, 'YYYY-MM-DD').startOf('day');
    const daysSinceBase = date.diff(baseDate.clone().startOf('day'), 'days');
    return daysSinceBase % 2 === 0 ? '甲' : '乙';
  };



  const getMaxLeave = (dateStr) => {
    const 班別 = isSupervisor ? getDateShiftType(dateStr) : shiftType;
    const 班別人數 = 班別清單[班別]?.length || 0;
    const 值日人數 = dutyByDate[dateStr]?.length || 0;
    const 有分隊長值日 = dutyByDate[dateStr]?.some(name => name.includes('分隊長'));

    // const 加成 = 有分隊長值日 ? 1 : 0;

    const 總上班人數 = 班別人數 + 值日人數;
    return Math.max(0, 總上班人數 - minOnDuty);
  };

  const getMaxNight = (dateStr) => {
    const 班別 = isSupervisor ? getDateShiftType(dateStr) : shiftType;
    const 班別人數 = 班別清單[班別]?.length || 0;
    const 值日人數 = dutyByDate[dateStr]?.length || 0;
    const 總上班人數 = 班別人數 + 值日人數;

    return Math.max(0, 總上班人數 - minOnDuty);
  };




  // const getRemainingLeave = (dateStr) => {
  //   const baseLimit = selectedLimits[dateStr]?.leave || 0;

  //   // ✅ 如果 dutyByDate 有人值日，加 1
  //   const hasDuty = (dutyByDate[dateStr]?.length || 0) > 0;
  //   const adjustedLimit = baseLimit + (hasDuty ? 1 : 0);

  //   const applicants = leaveApplicationsByDate[dateStr] || [];
  //   const used = applicants.filter(l => !l.user.includes('分隊長')).length;

  //   return Math.max(0, adjustedLimit - used);
  // };

  // const getRemainingLeave = (dateStr) => {
  //   const max = getMaxLeave(dateStr); // ✅ 改為動態計算
  //   const applicants = leaveApplicationsByDate[dateStr] || [];

  //   // ✅ 分隊長請假不列入消耗
  //   const used = applicants.filter(l => !l.user.includes('分隊長')).length;

  //   return Math.max(0, max - used);
  // };

  const getDailyLimitSplit = (dateStr) => {
    const total = getMaxLeave(dateStr);
    const manualLeave = selectedLimits[dateStr]?.leave;

    if (typeof manualLeave === 'number') {
      const night = Math.max(0, total - manualLeave);
      return { leave: manualLeave, night };
    } else {
      return { leave: total, night: 0 };
    }
  };



  // const getRemainingCombinedQuota = (dateStr) => {

  //   const total = getMaxLeave(dateStr);
  //   const manualLeave = selectedLimits[dateStr]?.leave;

  //   const leave = typeof manualLeave === 'number' ? manualLeave : total;
  //   const night = Math.max(0, total - leave);

  //   const applicants = (leaveApplicationsByDate[dateStr] || []).filter(l => !l.user.includes('分隊長')).length;
  //   // console.log("📅", dateStr, "→ leaveApplications:", leaveApplicationsByDate[dateStr]);
  //   const used = applicants.length;
  //   const leaveRemain = Math.max(0, leave - applicants);
  //   const nightRemain = leaveRemain === 0 ? Math.max(0, leave + night - applicants) : 0;

  //   // console.log(`📅 ${dateStr} → leave=${leave}, night=${night}, used=${used}`);


  //   return { leave: leaveRemain, night: nightRemain };
  // };

  const getRemainingCombinedQuota = (dateStr) => {
    const { leave, night } = getDailyLimitSplit(dateStr);
    const applicants = (leaveApplicationsByDate[dateStr] || []).filter(l => !l.user.includes('分隊長')).length;
    const used = applicants;

    const leaveRemain = Math.max(0, leave - used);
    const nightRemain = Math.max(0, night - Math.max(0, used - leave));

    return { leave: leaveRemain, night: nightRemain };
  };




  const getRemainingLeave = (dateStr) => {
    const manualLimit = selectedLimits[dateStr]?.leave;
    const applicants = leaveApplicationsByDate[dateStr] || [];

    // ✅ 只計入補休（08:00 → 08:00），排除夜宿與白宿
    const used = applicants.filter(l => {
      const from = moment(l.from_time);
      const to = moment(l.to_time);
      return (
        from.format('HH:mm') === '08:00' &&
        to.format('HH:mm') === '08:00' &&
        !l.user.includes('分隊長')
      );
    }).length;

    if (typeof manualLimit === 'number') {
      return Math.max(0, manualLimit - used);
    }

    const max = getMaxLeave(dateStr);
    return Math.max(0, max - used);
  };



  const getRemainingNight = (dateStr) => {
    const { leave, night } = getDailyLimitSplit(dateStr);
    const total = leave + night;

    const applicants = leaveApplicationsByDate[dateStr] || [];
    const used = applicants.filter(l => !l.user.includes('分隊長')).length;

    return Math.max(0, total - used);
  };




  useEffect(() => {
    if (!calendarDates.length) return; // ✅ 只檢查是否有日期

    let 白宿總剩餘 = 0;

    calendarDates.forEach(dateStr => {
      const 非週末 = !isWeekend(dateStr);
      const applicants = leaveApplicationsByDate[dateStr] || [];
      const 分隊長請假 = applicants.some(l => l.user.includes('分隊長'));
      const 有值日 = (dutyByDate[dateStr]?.length || 0) > 0;

      if (非週末 && !分隊長請假 && !有值日) {
        白宿總剩餘 += getRemainingOvernight(dateStr);
      }
    });

    // console.log("✅ 白宿總剩餘 = ", 白宿總剩餘);
    setTotalOvernightRemaining(白宿總剩餘);
  }, [calendarDates, leaveApplicationsByDate, dutyByDate, selectedLimits]);


  const getBaseRemainingLeave = (dateStr) => {
    const max = selectedLimits[dateStr]?.leave || 0;
    const used = usedLeaveCount[dateStr] || 0;
    return Math.max(0, max - used);
  };


  // const getRemainingStay = (date) => {
  //   const max = selectedLimits[date]?.stay || 0;
  //   const used = usedStayCount[date] || 0;
  //   return Math.max(0, max - used);
  // };

  const getRemainingStay = (dateStr) => {
    let stayLimit = typeof selectedLimits[dateStr]?.stay === 'number'
      ? selectedLimits[dateStr].stay
      : 1; // ✅ 預設值

    const applicants = leaveApplicationsByDate[dateStr] || [];
    const dutyLeaders = dutyByDate[dateStr] || [];

    const 有分隊長值日 = dutyLeaders.some(name => name.includes('分隊長'));
    const 有分隊長請假 = applicants.some(l => l.user.includes('分隊長'));

    if (有分隊長值日 || 有分隊長請假) {
      stayLimit -= 1;
    }

    const used = applicants.filter(l => {
      const from = moment(l.from_time);
      const to = moment(l.to_time);
      return from.format('HH:mm') === '08:00' && to.format('HH:mm') === '17:00';
    }).length;

    return Math.max(0, stayLimit - used);
  };


  const getRemainingLeaveForWhiteStay = (dateStr) => {
    const max = selectedLimits[dateStr]?.leave || 0;
    const used = usedLeaveCount[dateStr] || 0;
    return Math.max(0, max - used);
  };


  const applySameLimitToAll = (leave, stay) => {
    console.log("🟢 applySameLimitToAll 被呼叫");
    // const today = new Date();
    // const year = today.getFullYear();
    // const month = today.getMonth() + 1;
    const year = currentDate.year()
    const month = currentDate.month() + 1
    const dates = getShiftDates(year, month, shiftType); // 取得目前班別可申請日期

    const newLimits = {};
    dates.forEach((date) => {
      newLimits[date] = { leave, stay };
    });

    setSelectedLimits(newLimits);
  };

  // component 裡的函式
  const openSingleDateSetting = (date) => {
    const max = getMaxLeave(date); // ⬅️ 自動計算的休假名額
    const stayDefault = getRemainingStay(date); // 自動白宿名額
    const leaveStr = prompt(
      `設定 ${date} 的休假名額上限（預設為 ${max}位）`,
      String(max) // 👈 直接顯示自動值 例如 '4'
    );
    const stayStr = prompt(
      `設定 ${date} 的白宿名額上限（預設 ${stayDefault}位）`,
      String(stayDefault) // 👈 直接顯示 '1'
    );
    const leave = leaveStr === null || leaveStr.trim() === ''
      ? max
      : parseInt(leaveStr, 10);

    const stay = stayStr === null || stayStr.trim() === ''
      ? stayDefault
      : parseInt(stayStr, 10);

    if ((leave !== null && isNaN(leave)) || (stay !== null && isNaN(stay))) {
      alert("請輸入有效的數字或留空");
      return;
    }

    // const max = getMaxLeave(date); // ✅ 自動推算最大可請人數
    const night = (leave !== null) ? Math.max(0, max - leave) : 0; // ✅ 自動補夜假人數

    // ✅ 變更比對：如果都與原設定一致 → 不寫入
    const prev = selectedLimits[date] || {};
    const sameLeave = (prev.leave ?? max) === leave;
    const sameStay = (prev.stay ?? stayDefault) === stay;
    if (sameLeave && sameStay) {
      console.log(`⏩ ${date} 未變更，跳過更新`);
      return;
    }

    setSelectedLimits(prev => {
      const updated = { ...prev };

      // ✅ 若 leave 和 stay 都為 null，刪除整筆設定
      if (leave === null && stay === null) {
        delete updated[date];
      } else {
        updated[date] = {
          ...(updated[date] || {}),
          ...(leave !== null ? { leave } : {}),
          ...(stay !== null ? { stay } : {}),
          night // ✅ 自動加入 night_limit
        };
      }

      return updated;
    });
  };

  // const openSingleDateSetting = (date) => {
  //   const leaveStr = prompt(`設定 ${date} 的請假上限（留空則使用自動計算）`, selectedLimits[date]?.leave ?? '');
  //   const stayStr = prompt(`設定 ${date} 的白宿上限（留空則當作 1）`, selectedLimits[date]?.stay ?? '');

  //   const leave = leaveStr.trim() === '' ? null : parseInt(leaveStr, 10);
  //   const stay = stayStr.trim() === '' ? 1 : parseInt(stayStr, 10);

  //   if ((leave !== null && isNaN(leave)) || (stay !== null && isNaN(stay))) {
  //     alert("請輸入有效的數字或留空");
  //     return;
  //   }

  //   setSelectedLimits(prev => {
  //     const updated = { ...prev };

  //     // ✅ 若 leave 和 stay 都為 null，移除整個日期設定
  //     if (leave === null && stay === null) {
  //       delete updated[date];
  //     } else {
  //       // ✅ 部分欄位仍保留
  //       updated[date] = {
  //         ...(updated[date] || {}),
  //         ...(leave !== null ? { leave } : {}),
  //         ...(stay !== null ? { stay } : {})
  //       };
  //     }

  //     return updated;
  //   });
  // };


  const saveLeaveLimitsToServer = async () => {
    // ✅ 從已載入過的資料找出所有曾經設定的日期
    const allDates = Object.keys(originalLimits); // ← originalLimits 是你一開始從 DB 載入的 selectedLimits 副本

    const currentDates = Object.keys(selectedLimits);
    const deletedDates = allDates.filter(date => !currentDates.includes(date));
    console.log("🧹 刪除以下日期：", deletedDates);

    // ✅ 準備要儲存的資料（保留有設定的）
    const payload = Object.entries(selectedLimits)
      .map(([date, limits]) => ({
        date,
        shiftType,
        leaveLimit: typeof limits.leave === 'number' ? limits.leave : null,
        stayLimit: typeof limits.stay === 'number' ? limits.stay : null,
        nightLimit: typeof limits.night === 'number' ? limits.night : null // ✅ 新增這行
      }))
      .filter(item =>
        item.leaveLimit !== null ||
        item.stayLimit !== null ||
        item.nightLimit !== null // ✅ 新增這行過濾條件
      );


    try {
      const res = await fetch('/api/leave-limits/batch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shiftType, payload, deletedDates }), // ✅ 加上 deletedDates
      });

      const result = await res.json();
      if (result.success) {
        // alert("✅ 設定已儲存");
        await loadLeaveLimitsFromServer();
        setLimitModalOpen(false);
      } else {
        alert("❌ 儲存失敗：" + result.error);
      }
    } catch (err) {
      console.error("❌ 儲存發生錯誤", err);
      alert("系統錯誤，請稍後再試");
    }
  };




  const loadLeaveLimitsFromServer = async () => {
    const year = currentDate.year();
    const month = (currentDate.month() + 1).toString().padStart(2, '0');
    const monthStr = `${year}-${month}`;

    const shiftTypes = isSupervisor ? ['甲', '乙'] : [shiftType];

    try {
      const results = await Promise.all(
        shiftTypes.map(type =>
          fetch(`/api/leave-limits?month=${monthStr}&shiftType=${type}`)
            .then(res => res.json())
        )
      );

      const combined = results.flat();
      // console.log('fdasf',combined);
      const newLimits = {};
      combined.forEach(item => {
        const dateStr = moment(item.date).format("YYYY-MM-DD");
        newLimits[dateStr] = {
          leave: typeof item.leave_limit === 'number' ? item.leave_limit : null,
          stay: typeof item.stay_limit === 'number' ? item.stay_limit : null,
          night: typeof item.night_limit === 'number' ? item.night_limit : 0  // ✅ 僅接受數字，否則預設為 0
        };
      });

      setSelectedLimits(newLimits);
      setIsLimitLoaded(true);
      setOriginalLimits({ ...newLimits }); // ✅ 同步備份，供比對刪除日期

    } catch (err) {
      console.error("讀取限制資料失敗", err);
    }
  };

  const goToPreviousMonth = () => {
    setCurrentDate(prev => moment(prev).subtract(1, "months"));
  };

  const goToNextMonth = () => {
    setCurrentDate(prev => moment(prev).add(1, "months"));
  };

  const refreshCalendar = () => {
    setCurrentDate(prev => moment(prev).add(1, 'month'));
    setTimeout(() => {
      setCurrentDate(prev => moment(prev).subtract(1, 'month'));
    }, 100);
  };

  const openNotifySortModal = () => {
    const sortedStaff = 班別清單[shiftType]?.map((person, i) => ({
      id: person.id,
      name: person.name,
      lineId: person.lineId || `U${person.id}`, // 預設 lineId，如果沒有也補一個
      hasSubmitted: false,
    })) || [];

    // setNotifyList(sortedStaff);
    setNotifyList([]); // 每次開啟重新選
    setIsSortModalOpen(true);
    // console.log('📦 載入通知人員名單：', sortedStaff);

  };

  const handleClearNotifyProgress = async () => {
    const month = moment(currentDate).format('YYYY-MM');
    const confirmClear = window.confirm(
      `⚠️ 確定要清空 ${month} ${shiftType}班 的「排序設定」與「通知進度」嗎？\n\n排序名單將一併刪除，需重新設定。此操作無法復原。`
    );
    if (!confirmClear) return;

    try {
      const res = await fetch(`/api/notify-progress/clear`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ month, shiftType }),
      });

      const result = await res.json();
      if (result.success) {
        setNotifyList([]);
        setIsSortModalOpen(false);
        fetchCurrentNotifyInfo();
      } else {
        alert("❌ 清除失敗：" + result.message);
      }
    } catch (err) {
      console.error("❌ 清除失敗", err);
      alert("系統錯誤，請稍後再試");
    }
  };

  const handleResetNotifyProgress = async () => {
    const month = moment(currentDate).format('YYYY-MM');
    const confirmReset = window.confirm(
      `確定要重置 ${month} ${shiftType}班 的「通知進度」嗎？\n\n排序設定將保留，進度將從第 1 位重新開始。`
    );
    if (!confirmReset) return;

    try {
      const res = await fetch('/api/notify-progress/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ month, shiftType }),
      });

      const result = await res.json();
      if (result.success) {
        alert(`✅ ${result.message}\n目前輪到：${result.firstUser}`);
        fetchCurrentNotifyInfo();
      } else {
        alert("❌ 重置失敗：" + result.message);
      }
    } catch (err) {
      console.error("❌ 重置失敗", err);
      alert("系統錯誤，請稍後再試");
    }
  };

  const getTotalRemainingCombined = (dateStr) => {
    const totalLimit = getMaxLeave(dateStr); // 自動模式下的最大名額
    const manualLeave = selectedLimits[dateStr]?.leave;

    // 實際分配
    const leave = typeof manualLeave === 'number' ? manualLeave : totalLimit;
    const night = Math.max(0, totalLimit - leave);

    const used = (leaveApplicationsByDate[dateStr] || []).filter(l => !l.user.includes('分隊長')).length;

    return Math.max(0, leave + night - used);
  };


  // const totalRemaining = calendarDates.reduce(
  //   (sum, date) => sum + getRemainingLeave(date),
  //   0
  // );

  const totalRemaining = useMemo(() => {
    return calendarDates.reduce((sum, dateStr) => {
      const { leave } = getRemainingCombinedQuota(dateStr);
      return sum + leave;
    }, 0);
  }, [calendarDates, leaveApplicationsByDate, selectedLimits, dutyByDate, minOnDuty]);

  const totalNightRemaining = useMemo(() => {
    return calendarDates.reduce((sum, dateStr) => {
      const { night } = getRemainingCombinedQuota(dateStr);
      return sum + night;
    }, 0);
  }, [calendarDates, leaveApplicationsByDate, selectedLimits, dutyByDate]);





  const saveOfficerList = async () => {
    const ids = officerList.map(s => s.id);
    try {
      const res = await fetch('/api/staff/update-officers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids }),
      });
      const result = await res.json();
      if (result.success) {
        alert("✅ 幹部名單已儲存");
        setIsOfficerModalOpen(false);
      } else {
        alert("❌ 儲存失敗：" + result.message);
      }
    } catch (err) {
      console.error("❌ 儲存幹部名單錯誤", err);
      alert("❌ 發生錯誤，請稍後再試");
    }
  };

  const fetchOfficerList = async () => {
    try {
      const res = await fetch('/api/staff/officers');
      const data = await res.json();
      if (data.success) {
        setOfficerList(data.officers);
      } else {
        alert("❌ 無法載入幹部名單");
      }
    } catch (err) {
      console.error("載入 officer list 錯誤", err);
      alert("❌ 發生錯誤，無法載入幹部名單");
    }
  };


  const handleLogin = () => {
    localStorage.setItem('auth', 'true');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth');
    setIsAuthenticated(false);
  };

  const handleToggleLineNotify = async () => {
    const newValue = lineNotifyEnabled ? 0 : 1;
    try {
      const res = await fetch('/api/system-setting', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: 'lineNotifyEnabled', value: newValue }),
      });
      const result = await res.json();
      if (result.success) {
        setLineNotifyEnabled(newValue === 1);
        setIsMenuOpen(false);
      } else {
        alert('❌ 設定失敗');
      }
    } catch (err) {
      console.error(err);
      alert('❌ 系統錯誤');
    }
  };


  return (
    <div className={`relative p-2 bg-gradient-to-br from-cyan-100 via-teal-500 to-white min-h-screen w-full max-w-screen overflow-x-hidden ${!lineNotifyEnabled ? 'pt-11' : ''}`}>

      {!lineNotifyEnabled && (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-100 text-amber-900 text-center py-2 text-sm font-medium shadow-sm">
          測試模式：LINE 通知已關閉
        </div>
      )}

      <div className="flex justify-end items-center gap-2  px-3">
        <div className="font-bold text-red-900 text-lg tracking-wide">
          {moment(currentDate).format('YYYY 年 MM 月')}
        </div>
        <button
          onClick={goToPreviousMonth}
          className="p-2 bg-teal-800 text-teal-100 rounded-l  transition-all  font-semibold "
          style={{
            clipPath: 'polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px)',
          }}
        >
          上個月
        </button>



        <button
          onClick={goToNextMonth}
          className="p-2 bg-teal-800 text-teal-100 rounded-l  transition-all  font-semibold"
          style={{
            clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 0 100%)',
          }}
        >
          下個月
        </button>
      </div>




      <div className=" mt-2 shadow-xl bg-white w-full">
        {!isLimitLoaded ? (
          <div className="text-center text-gray-500 mt-4">🔄 載入中...(請選取申請人員)</div>
        ) : (
          <Calendar
            key={JSON.stringify(selectedLimits)} // ✅ 強制更新日曆內容
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable={true} // ✅ 正確用法
            longPressThreshold={1}
            onSelectSlot={handleSelectSlot}
            onNavigate={handleNavigate}
            date={currentDate}
            style={{ height: 'calc(100vh - 320px)', width: '100%' }}
            popup
            views={['month']}
            messages={{
              allDay: '全天', previous: '上個月', next: '下個月', today: '今天',
              month: '月', week: '週', day: '日', agenda: '行事曆',
              date: '日期', time: '時間', event: '事件', noEventsInRange: '目前沒有事件',
            }}
            formats={formats}
            dayPropGetter={dayPropGetter}
            components={{
              toolbar: () => null,
              dateCellWrapper: DateCellWrapper,
              month: {
                header: CustomDayHeader
              }
            }}
          />
        )}

        {/* 左下角統計視窗 */}
        {totalRemaining === 0 && totalNightRemaining === 0 ? (
          <div className="text-center text-red-500 font-semibold mt-4">
            🚫 本月已額滿，無可申請名額
          </div>
        ) : !currentNotifyInfo?.name ? (
          <div className="text-center text-gray-400 italic mt-4">
            尚未開始通知，或已全部填完
          </div>
        ) : (
          <div className="text-center mt-4">
            目前輪到：
            <span className="font-bold text-teal-700">
              {currentNotifyInfo.name}
            </span>
            <span className="ml-2 text-sm text-gray-500">
              （第 {currentNotifyInfo.round || '?'} 輪，第 {currentNotifyInfo.order || '?'} 位）
            </span>
          </div>
        )}




        <div className="shadow px-2 py-2 text-gray-800 text-center font-semibold">
          <div>休假剩餘({totalRemaining})，外宿剩餘({totalNightRemaining})，白宿剩餘({totalOvernightRemaining})
          </div>
        </div>
      </div>


      <div className="flex flex-col items-center gap-2 mt-2">
        <select
          value={selectedStaff}
          onChange={handleStaffChange}
          className="text-lg  p-2 rounded-xl shadow border border-teal-300 focus:outline-none bg-white w-40 text-center"
        >
          <option value="">選擇申請人員</option>
          {staffList.map((staff) => (
            <option key={staff.id} value={staff.name}>{staff.name}</option>
          ))}
        </select>

        <button
          onClick={toggleShift}
          className="bg-teal-500 hover:bg-teal-600 text-white font-semibold p-2 rounded-xl shadow border border-white text-lg w-40"
        >
          {shiftType}班模式
        </button>


        {/* 👇 在這裡插入提示文字 */}
        {isSupervisor && (
          <div className="text-sm text-gray-500 mt-2 text-center">
            你目前可查看全部班別的請假資料
          </div>
        )}


      </div>

      {/* 左上角 menu 開關按鈕 */}
      <div className={`absolute left-2 z-50 ${!lineNotifyEnabled ? 'top-12' : 'top-2'}`}>
        <button
          onClick={() => {
            if (isAuthenticated) {
              setIsMenuOpen(prev => !prev);
            } else {
              setShowPasswordPrompt(true);
            }
          }}
          className="bg-teal-600 text-white px-5 py-2 mb-2 rounded shadow  hover:bg-teal-700 transition-all"
        >
          {isMenuOpen ? '關閉' : '選單'}
        </button>
        <div
          className={`relative transition-all duration-300 bg-gradient-to-br from-white via-teal-100 to-white shadow-xl rounded-xl overflow-hidden  ${isMenuOpen ? 'max-h-100 p-7 w-full' : 'max-h-0 p-0 w-full overflow-hidden'}`}
        >
          <button
            onClick={() => setIsMenuOpen(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-red-600 text-xl font-bold"
          >
            關閉
          </button>

          <button
            onClick={() => {
              setIsMenuOpen(false);
              setIsDutyModalOpen(true); // 👈 開啟值日 modal
            }}
            className="block w-full text-left px-4 py-2 hover:bg-teal-50  text-teal-700"
          >
            1.設定分隊長值日
          </button>
          <button
            className="block w-full text-left px-4 py-2 hover:bg-teal-50  text-teal-700"

            onClick={() => { setLimitModalOpen(true); setIsMenuOpen(false); }}
          >
            2.請假人數設定
          </button>

          <button
            onClick={() => {
              setIsMenuOpen(false);
              openNotifySortModal();
            }}
            className="block w-full text-left px-4 py-2 hover:bg-teal-50 text-teal-700"
          >
            9.通知排序
          </button>

          <button
            onClick={async () => {
              const monthStr = moment(currentDate).format('YYYY-MM');

              if (!window.confirm(`確定要刪除 ${monthStr} ${shiftType}班 所有請假紀錄？（排除幹部）`)) return;

              try {
                const res = await fetch(`/api/delete-leave-month?month=${monthStr}&shiftType=${shiftType}`, {
                  method: 'DELETE'
                });
                const result = await res.json();

                if (result.success) {
                  alert(`✅ 已刪除 ${result.affectedRows} 筆紀錄`);
                  setIsMenuOpen(false);
                  fetchMyLeaveDates();
                  fetchUsedLeaveCount();
                  loadLeaveLimitsFromServer();
                  refreshCalendar()
                } else {
                  alert("❌ 刪除失敗：" + result.message);
                }
              } catch (err) {
                console.error(err);
                alert("❌ 系統錯誤");
              }
            }}
            className="block w-full text-left px-4 py-2 hover:bg-red-100  text-red-600"
          >
            一次刪除本班整月紀錄
          </button>

          <button
            onClick={() => {
              setIsMenuOpen(false);
              setIsShiftModalOpen(true);

            }}
            className="block w-full text-left px-4 py-2 hover:bg-teal-50  text-teal-700"
          >調整班別</button>

          <button
            onClick={() => {
              setIsMenuOpen(false);
              setIsStaffViewOpen(true); // 👈 開啟改名視窗
            }}
            className="block w-full text-left px-4 py-2 hover:bg-teal-50 text-teal-700"
          >
            番號管理
          </button>

          <button
            onClick={async () => {
              setIsMenuOpen(false);
              await fetchOfficerList(); // ⬅️ 載入幹部名單
              setIsOfficerModalOpen(true); // 👈 開啟幹部設定 modal
            }}
            className="block w-full text-left px-4 py-2 hover:bg-teal-50 text-teal-700"
          >
            免限制名單(幹部)
          </button>

          {isAuthenticated && (
            <button
              onClick={handleToggleLineNotify}
              className={`block w-full text-left px-4 py-2 ${
                lineNotifyEnabled
                  ? 'hover:bg-teal-50 text-teal-700'
                  : 'hover:bg-amber-50 text-amber-800 font-medium'
              }`}
            >
              LINE 通知：{lineNotifyEnabled ? '開啟' : '關閉（測試模式）'}
            </button>
          )}

          {isAuthenticated && (
            <button
              onClick={() => {
                handleLogout();
                setIsMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-yellow-50 text-yellow-700"
            >
              登出
            </button>
          )}

        </div>
      </div>

      {/* 請假 Modal */}
      <LeaveModal
        isOpen={isModalOpen}
        isClosing={isClosing}
        showModalContent={showModalContent}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        selectedStaff={selectedStaff}
        staffList={staffList}
        agent={agent}
        setAgent={setAgent}
        leaveType={leaveType}
        setLeaveType={setLeaveType}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        dayLeaveRecords={dayLeaveRecords}
        fetchDayLeaveRecords={fetchDayLeaveRecords}
        fetchMyLeaveDates={fetchMyLeaveDates}
        fetchUsedLeaveCount={fetchUsedLeaveCount}
        loadLeaveLimitsFromServer={loadLeaveLimitsFromServer}
        refreshCalendar={refreshCalendar}
        canSubmit={getRemainingLeave(moment(modalDate).format('YYYY-MM-DD')) > 0 ||
          getRemainingNight(moment(modalDate).format('YYYY-MM-DD')) > 0}

        isAlreadyApplied={myLeaveDates.includes(moment(modalDate).format("YYYY-MM-DD"))}
        isAuthenticated={isAuthenticated}
        isSubmitting={isSubmitting}
      />

      {/* 人員分班 Modal */}
      <ShiftModal
        isOpen={isShiftModalOpen}
        onClose={() => setIsShiftModalOpen(false)}
        shiftType={shiftType}
        班別清單={班別清單}
        未分班清單={未分班清單}
        assignViaClick={assignViaClick}
        handleDragStart={handleDragStart}
        handleShiftDrop={handleShiftDrop}
        handleRemoveFromShift={handleRemoveFromShift}
      // className="transition-all duration-300 transform bg-white rounded-lg p-6 w-[90%] max-w-4xl mx-auto mt-20 shadow-xl z-60 sm:w-[90%]"
      // overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 overflow-auto"
      />

      {/* ✅ 新增 StaffView (只負責改名) */}
      <StaffView
        isOpen={isStaffViewOpen}
        onClose={() => setIsStaffViewOpen(false)}
        staffList={staffList}        // 傳入全體名單
        onUpdateName={handleUpdateName} // 傳入改名函式
      />

      {/* 限制人數 Modal */}
      <LeaveLimitModal
        isOpen={isLimitModalOpen}
        onClose={() => setLimitModalOpen(false)}
        shiftType={shiftType}
        currentDate={currentDate}
        goToPreviousMonth={goToPreviousMonth}
        goToNextMonth={goToNextMonth}
        calendarDates={calendarDates}
        getRemainingLeave={getRemainingLeave}
        getRemainingStay={getRemainingStay}
        getRemainingNight={getRemainingNight}
        getDailyLimitSplit={getDailyLimitSplit}
        leaveApplicationsByDate={leaveApplicationsByDate}
        openSingleDateSetting={openSingleDateSetting}
        applySameLimitToAll={applySameLimitToAll}
        saveLeaveLimitsToServer={saveLeaveLimitsToServer}
        selectedLimits={selectedLimits}
        setSelectedLimits={setSelectedLimits} // ✅ 傳入 setter
        minOnDuty={minOnDuty}
        setMinOnDuty={setMinOnDuty}
        setLimitModalOpen={setLimitModalOpen}
        className="transition-all duration-300 transform bg-white rounded-lg p-6 w-[90%] max-w-4xl mx-auto mt-20 shadow-xl z-60 sm:w-[90%]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 overflow-auto"
      />

      {/* 通知 */}
      <NotifySortModal
        isOpen={isSortModalOpen}
        onClose={() => setIsSortModalOpen(false)}
        notifyList={notifyList}
        setNotifyList={setNotifyList}
        shiftList={班別清單[shiftType] || []} // 👈 傳入當前班別清單
        notifyDate={currentDate}   // 👈 加這行
        shiftType={shiftType}         // ✅ 傳入班別
        fetchCurrentNotifyInfo={fetchCurrentNotifyInfo}  // ✅ 傳進 modal
        handleClearNotifyProgress={handleClearNotifyProgress}
        handleResetNotifyProgress={handleResetNotifyProgress}
      />

      {/* 值日 */}
      <DutyModal
        isOpen={isDutyModalOpen}
        onClose={() => setIsDutyModalOpen(false)}
        currentDate={currentDate}
        calendarDates={allDates}
        staffList={staffList}
        dutyByDate={dutyByDate}
        setDutyByDate={setDutyByDate}
      />

      {/* 幹部名單 */}
      <OfficerModal
        isOpen={isOfficerModalOpen}
        onClose={() => setIsOfficerModalOpen(false)}
        staffList={staffList}
        officerList={officerList}
        setOfficerList={setOfficerList}
        assignViaClick={assignViaClick}
        handleDragStart={handleDragStart}
        saveOfficerList={saveOfficerList}
      />

      {showPasswordPrompt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-80">
            <h2 className="text-lg font-bold mb-2">請輸入密碼</h2>
            <input
              type="password"
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
              className="w-full p-2 border rounded mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                className="px-3 py-1 bg-gray-300 rounded"
                onClick={() => setShowPasswordPrompt(false)}
              >
                取消
              </button>
              <button
                className="px-3 py-1 bg-teal-600 text-white rounded"
                onClick={async () => {
                  try {
                    const res = await fetch('/api/verify-password', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ password: inputPassword })
                    });
                    if (res.ok) {
                      handleLogin(); // ✅ 成功後設定登入狀態
                      setIsMenuOpen(true); // ⬅️ 若有主選單可顯示
                    } else {
                      alert("❌ 密碼錯誤");
                    }
                  } catch (err) {
                    alert("❌ 系統錯誤");
                  }
                  setShowPasswordPrompt(false);
                  setInputPassword('');
                }}
              >
                確認
              </button>
            </div>
          </div>
        </div>
      )}






    </div>
  );
};





export default LeaveCalendar;
